<script setup lang="ts">
defineProps<{ disabled?: boolean }>();
defineSlots<{ default: () => void }>();
</script>

<template>
  <button
    type="button"
    :disabled
    class="px-r3 py-r4 border-client-gray-darker rounded-lg border disabled:cursor-not-allowed disabled:opacity-50"
  >
    <slot />
  </button>
</template>
